"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAirportState = exports.setFoundAirportsAction = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const DEFAULT_STATE = {
    destinationAirports: [],
    departureAirports: [],
};
const airportSlice = (0, toolkit_1.createSlice)({
    name: 'airport',
    initialState: DEFAULT_STATE,
    reducers: {
        setFoundAirports: (state, action) => {
            return {
                ...state,
                [action.payload.location === 'departure' ? 'departureAirports' : 'destinationAirports']: action.payload.airports
            };
        },
        resetAirportState: () => {
            return DEFAULT_STATE;
        }
    }
});
exports.default = airportSlice.reducer;
exports.setFoundAirportsAction = airportSlice.actions.setFoundAirports;
exports.resetAirportState = airportSlice.actions.resetAirportState;
